import $ from "jquery";
import breadcrumb from './breadcrumb';
import content from './content';
import "fantdu/dist/fantdu.min";
import language from "../../scripts/translation";




export default function(client) {

    const breadcrumbHtml = breadcrumb();
    document.title = "Nyheter";

    let nameId = client.nameId || "";

    // console.log("[in article: before content]");
    content();
    // console.log("[in article: after content]");


    window.fantdu__success = function(result) {

        let traces = [];

        result.trace.$values.forEach(data => {

            let time = data.timeOut / 1000;
            
            

            traces.push(`
                <li>${time} sek, <a href="${decodeURIComponent(data.pageUrl)}">${decodeURIComponent(data.pageName)}</a></li>
           `)
           
        //   console.log("traces", `
        //         <li>${time} sek, <a href="${decodeURIComponent(data.pageUrl)}">${data.pageName}</a></li>
        //   `);

        });

        let comment = ``;
        
        // console.log(result.comment, result.comment.length, comment)

        if (result.comment.length > 0) {
            console.log("comment inside", result.comment);
            comment = `${result.comment}`;
        }
        
        
        // console.log("result - fantdu : ", result)

        traces = traces.join("");

        let fantdu__comment = `<span class="badge badge-${(result.isPositive ? "success\">Positiv" : "danger\">Negativ")}</span>
            <br/>
            ${comment}
            <br/><br/>
            <h6>Sporing:</h6>
            <ol>
            ${traces}
            </ol>
        `;



        let data = {
            "taskFinished": false,
            "taskDescription": fantdu__comment,
            "title": `Fantdu (${(result.isPositive ? "Positiv" : "Negativ")}) ${comment.length < 1 ? "Ingen kommentar" : comment.substr(0,20)+"..."}`,
            "subscriptionId": contentSubscription,
            "contentId": contentID,
            "taskState": 0,
            "taskType": "FantDu"
        };
        
        // console.log("data fantdu: ", data);

        let senddata = JSON.stringify(data);
        
        // console.log("sendata fantdu ok", senddata);


        // Get JSON 
        $.ajax({
            type: "POST",
            url: window.apiUrl + "/api/UserTaskApi/create",
            contentType: "application/json-patch+json",
            data: senddata,
            headers : { "subscriptionId" : client.clientId }
        }).done(function(alle) {

        });


    }

    window.fandu__failed = function(result) {

        let traces = [];

        result.trace.$values.forEach(data => {

            let time = data.timeOut / 1000;

            traces.push(`
                <li>${time} sek, <a href="${data.pageUrl}">${data.pageName}</a></li>
           `)

        });

        let comment = ``;

        if (result.comment.length > 0) {
            comment = `${result.comment}`;
        }
        // console.log("result - fantdu : ", result)

        traces = traces.join("");

        let fantdu__comment = `
            Fantdu feilet, returnerer res etter stat:<br>
            <span class="badge badge-${(result.isPositive ? "success\">Positiv" : "danger\">Negativ")}</span>
            <br/>
            ${comment}
            <br/><br/>
            <h6>Sporing:</h6>
            <ol>
            ${traces}
            </ol>
        `;



        let data = {
            "taskFinished": false,
            "taskDescription": fantdu__comment,
            "title": `Fantdu (${(result.isPositive ? "Positiv" : "Negativ")}) ${comment.length < 1 ? "Ingen kommentar" : comment.substr(0,20)+"..."}`,
            "subscriptionId": contentSubscription,
            "contentId": contentID,
            "taskState": 0,
            "taskType": "FantDu"
        };

        let senddata = JSON.stringify(data);
        
        // console.log("sendata fantdu error", senddata);

        // Get JSON
        $.ajax({
            type: "POST",
            url: window.apiUrl + "/api/UserTaskApi/create",
            contentType: "application/json-patch+json",
            data: senddata,
        }).done(function(alle) {

        });


    }


    return `
    
        <div class="container">
            ${breadcrumbHtml}
        </div>
        <div class="container " id="contentHtml">
        
                <div class="row">
                    <div class="col-sm-12 text-center">
                    
                        <div class="spinner-border" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                                          
                    </div>
                </div>
        
        </div>
        <div class="fant_du_container"> 
            <fant-du client="${nameId}" placeholder-text="${language("FANTDU_PLACEHOLDER")}" pre-textarea-text="${language("FANTDU_PRETEXT")}"  post-message="${language("FANTDU_POSTTEXT")}" onSubmitSuccess="fantdu__success" onSubmitFail="fandu__failed" css="
            :host{
                display:block;
                min-width:320px;
            }
            
            .fant-du__center{
                text-align:center;
            }
            
            .fant-du__heading{
                font-family: inherit;
                font-size: 24px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.5;
                letter-spacing: normal;
                text-align: center;
                color: #1e1e1e;
                margin-bottom:15px;
            }
            
            .fant-du__buttons{
                display:flex;
                justify-content:center;
                margin: 0 auto;
            }
            
            .fant-du__button{
                border: none;
                padding: 12px 0;
                width: 112px;
            
                border-radius:4px;
                border: 3px solid #fff;
                font-family: inherit;
                font-size: 18px;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: normal;
                letter-spacing: normal;
                color: #1e1e1e;
                background:#fff;
            }
            
            .fant-du__textarea{
                border-radius: 4px;
                background-color: rgba(112, 112, 112, 0.05);
                border:1px solid #555555;
                padding:14px 16px;
                font-family: inherit;
                font-size: 16px;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.5;
                letter-spacing: normal;
                color: #555555;
                margin: 2px 2px 20px 2px;
            }
            
            .fant-du__receipt{
                font-family: inherit;
                font-size: 16px;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.5;
                letter-spacing: normal;
                text-align: center;
                color: #1e1e1e;
            }
            
            .fant-du__textarea:focus{
                border: 3px solid #385dff;
                outline:none;
                margin: 0 0 17px 0;
            }
            
            .fant-du__button:hover{
                cursor:pointer;
            }
            
            .fant-du__button--yes{
                border-color:#008800;
                margin-right:25px;
            }
            
            .fant-du__button--yes:hover,
            .fant-du__button--yes:focus{
                background-color:#008800;
                color:#fff;
            }
            
            .fant-du__button--yes:active{
                border-radius: 4px;
                border-color: rgba(0,0,0,0.25);
                outline:0;
            }
            
            .fant-du__button--no{
                border-color:#cc0000;
            }
            
            .fant-du__button--no:hover,
            .fant-du__button--no:focus{
                background-color:#cc0000;
                color:#fff;
            }
            
            .fant-du__button--no:active{
                border-radius: 4px;
                border-color: #950000;
                outline:0;
            }
            
            .fant-du__button--submit{
                border-color:#385dff;
                background:#385dff;
                color:#fff;
                width: 170px;
                display:block;
                margin: 0 auto;
            }
            
            .fant-du__button--submit:hover,
            .fant-du__button--submit:focus{
                background-color:#1b41eb;
            }
            
            .fant-du__button--submit:active{
                border-radius: 4px;
                border-color: #01146c;
                outline:0;
            }
            
            .fant-du__mb-10{
                margin-bottom:10px !important;
            }
            .fant-du__mb-30{
                margin-bottom:30px !important;
            }"></fant-du> 
        </div>
        <div class="">
        </div>
    `;

}
